let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("becB8")).then(() => parcelRequire('172dN'));